import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../../components/MaterialButton";
import colors from "../../../../assest/theme/base/colors";
import { Box, Dialog } from "@mui/material";

import Addplan from "./add";
import ConfirmDialog from "../../../Utils/ConfirmDialog";
import MessagePopup from "../../../Utils/MessagePopup";
import TableActionItems from "../../../../components/tabel/components/actionItems";
import TabelStatusCard from "../../../../components/tabel/components/statusBox";
import TanstackTableComponents from "../../../../components/tabel";
import axiosInstance, { API_URL } from "../../../Utils/url";
import { useLoading } from "../../../../context/loadingcontext";
import { useSnackbar } from "../../../../components/SnackbarProvider";
// import LoadingSpinner from "../../loader/loadercomp";

function Plan() {
  const [open, setOpen] = useState(false);
  const [view, setview] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [rowId, setRowId] = useState(null);
  const [formType, setFormType] = useState(null);
  const { setCirleLoading } = useLoading();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [editeddata, setEditeddata] = useState([]);
  const [editedtrue, setEditedtrue] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [openExport, setOpenExport] = useState(false);
  const [tabelCounts, setTabelCounts] = useState({
    totalItems: 0,
    totalPages: 0,
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [planList, setPlanList] = useState([]);
  const { showSnackbar } = useSnackbar();

  const columns = [
    {
      header: "Insurance Name",
      accessorKey: "insurance_name",
      cell: (props) => <p>{props.getValue()}</p>,
      meta: { sticky: true, left: 0 },
    },
    {
      header: "Plan Name",
      accessorKey: "plan_name",
      cell: (props) => <p>{props.getValue()}</p>,
      meta: { sticky: true, left: 120 },
    },
    {
      header: "Coverage Days",
      accessorKey: "annual_coverage_days",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Daily Cash Benefit",
      accessorKey: "daily_cash_benefit",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Accident Cover",
      accessorKey: "accident_cover",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Hospital Cash Limit",
      accessorKey: "hospital_cash_limit",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Wellness Benefit",
      accessorKey: "wellness_benefit",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Status",
      accessorKey: "is_active",
      cell: (props) => (
        <TabelStatusCard
          bg={props.getValue() ? "#d4edda" : "#f8d7da"}
          color={props.getValue() ? "#155724" : "#721c24"}
        >
          {props.getValue() ? "Active" : "Inactive"}
        </TabelStatusCard>
      ),
    },

    {
      header: "Created By",
      accessorKey: "created_by",
      cell: (props) => <p>{props.getValue()}</p>,
    },
    {
      header: "Actions",
      accessorKey: "actions",
      cell: (props) => (
        <TableActionItems
          row={props}
          onView={onView}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];

  const onView = (row) => {
    setRowId(row?.id);
    setFormType("view");
    setOpen(true);
  };

  const onDelete = (row) => {
    deletelist(row?.id);
  };

  const onEdit = (row) => {
    setRowId(row?.id);
    setOpen(true);
    setFormType("edit");
  };
  useEffect(() => {
    setFormType(null);
  }, []);

  useEffect(() => {
    fetchPlanConfig(pagination.pageIndex + 1);
  }, [pagination, open]);

  const fetchPlanConfig = async (pageNumber, searchText) => {
    setTableLoading(true);
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/insurance-plan/?page=${pageNumber}`
      );

      const success = response?.data?.success;
      const message = response?.data?.message;
      if (success) {
        setPlanList(response?.data?.data);
      } else {
        setPlanList([]);
      }
      setTabelCounts({
        totalItems: response?.data?.total_items,
        totalPages: response?.data?.total_pages,
      });
    } catch (err) {
      setPlanList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const formClose = () => {
    setOpen(false);
    setview(false);
  };
  const addRole = () => {
    setOpen(true);
    setFormType("add");
    setRowId(null);
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const deleteconfirm = async (id) => {
    deletecancel();
    setCirleLoading(true);
    try {
      const response = await axiosInstance.delete(
        `${API_URL}v1/insurance-plan/${id}/`
      );
      showSnackbar(response?.data?.message, "success");
    } catch (err) {
      showSnackbar(err?.response?.data?.message, "error");
    } finally {
      setCirleLoading(false);
      fetchPlanConfig(pagination.pageIndex + 1);
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => {},
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenExport={setOpenExport}
      name="Position Master"
    >
      {/* {Loader && <LoadingSpinner />} */}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />

      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-paper": {
            width: "800px", // Set your desired width
            maxWidth: "none", // Prevent it from limiting the width to default sizes
          },
        }}
      >
        <Addplan
          formClose={formClose}
          formType={formType}
          setOpen={setOpen}
          rowId={rowId}
        />
      </Dialog>

      <TanstackTableComponents
        rows={planList}
        columns={columns}
        pageCount={tabelCounts.totalPages}
        recordCount={tabelCounts.totalItems}
        addTitle="Add Insurance"
        heading="Plan Config List"
        isLoading={tableLoading} // loading enable
        isMore={false} // More options Enable
        isExport={true} // export options enable
        isUpload={true} // upload options enable
        isAdd={true} // add option enable
        isDateFilter={false} // date filter enable
        isSearch={true} // seacrh enable
        pagination={pagination}
        setPagination={setPagination}
        handleAdd={addRole}
      />
    </DashboardLayout>
  );
}

export default Plan;
